<template>
  <div class="welcome-text">
    <div v-if="userResponseError" class="user-error-banner">
      <span>Não foi possível carregar seus dados.</span>
      <button class="retry-btn" @click="retryLoadUser">
        <i class="fas fa-redo" /> Tentar novamente
      </button>
    </div>
    <template v-else-if="isConsultantAccess">
      <div class="consultant-access-banner">
        <span class="consultant-message">{{ consultantName }}</span>
        <b>&nbsp;{{ userName }}</b>
      </div>
      <div
        v-if="blockedByFinancialPlanningNotRead"
        class="consultant-warning-banner"
      >
        <i class="fas fa-info-circle"></i>
        O cliente ainda não confirmou o recebimento do plano financeiro.
      </div>
    </template>
    <template v-else>
      <span class="text-capitalize">
        Olá {{ userName }}!
      </span>
      <br v-if="isFreemium">
      <span v-if="isFreemium">
        Acesso grátis <b>{{ freemiumRemainingTime }}</b> dias restantes,
        <b style="cursor: pointer" @click="goToFinancialPLanning"
          >faça o seu diagnóstico gratuito aqui.</b
        >
      </span>
    </template>
  </div>
</template>

<script>
import { useAppStore } from "@/store/store.js";
export default {
  name: 'WelcomeMessage',
  computed: {
    userName() {
      const store = useAppStore();
      const user = store.userResponse.data;
      if (user) {
        return user.userFastapp?.name || 'Usuário';
      }
      return 'Usuário';
    },
    isConsultantAccess() {
      const store = useAppStore();
      return store.sessionInfo?.consultant_id != null;
    },
    consultantName(){
      const store = useAppStore();
      const sessionInfo = store.sessionInfo;
      if(sessionInfo){
        var consultantName = 'consultor, '; 
        if(sessionInfo.consultant_name){
          consultantName = sessionInfo.consultant_name + '! ';
        }
        var userAccessHeader = 'Olá ' + consultantName + 'Você está visualizando o app como planejador do(a) cliente -'
        return userAccessHeader;
      }
      return null;
    },
    isFreemium() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userInfo;
      if(user?.financial_management_active ||
        user?.is_pn_employee ||
        user?.other_running_products || 
        store.hasSubscriptionActive
      ){
        return false
      }
      return store.hasFreemiumAccess;
    },
    freemiumRemainingTime() {
      const store = useAppStore();
      return store.freemiumRemainingTime;
    },
    blockedByFinancialPlanningNotRead() {
      const store = useAppStore();
      return store.financialPlanningNotRead();
    },
    userResponseError() {
      const store = useAppStore();
      return store.userResponse.error;
    },
  },
  methods: {
    async goToFinancialPLanning() {
      const store = useAppStore();
      await store.goToFinancialPLanning();
    },
    retryLoadUser() {
      const store = useAppStore();
      store.userResponse.error = false;
      store.getUser();
    },
  }
};
</script>

<style scoped>
.welcome-text {
  font-size: small;
  color: white;
  line-height: 1.4;
}

b {
  color: #cb5540;
}

.consultant-access-banner {
  border: 1px solid #ff5722;
  width: fit-content;
  border-radius: 8px;
  padding: 8px 12px;
  margin: 5px 0;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.consultant-message {
  font-size: 13px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.consultant-warning-banner {
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  color: #fff;
  border: 1px solid #ffc107;
  background: rgba(255, 193, 7, 0.1);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.user-error-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #ff6800;
  font-size: 12px;
}

.retry-btn {
  background: transparent;
  border: 1px solid #ff6800;
  color: #ff6800;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 104, 0, 0.1);
  }
}
</style>